import { render, staticRenderFns } from "./SettingsLogs.vue?vue&type=template&id=3086a8ac&scoped=true"
import script from "./SettingsLogs.vue?vue&type=script&lang=js"
export * from "./SettingsLogs.vue?vue&type=script&lang=js"
import style0 from "./SettingsLogs.vue?vue&type=style&index=0&id=3086a8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3086a8ac",
  null
  
)

export default component.exports